import store from '../../store';

const sendWebSocketMessage = (message) => {
  const state = store?.getState();
  const websocketConnection = state.user.websocketConnection;
  if (
    websocketConnection &&
    websocketConnection.readyState === WebSocket.OPEN
  ) {
    websocketConnection.send(message);
  } else {
    // alert('The web socket is closed');
  }
};

export default sendWebSocketMessage;
